import React from 'react';
import { Query, graphql, withApollo } from "react-apollo";
import { NavLink } from 'react-router-dom'

import { formatDate, formatDateHTML } from '../../util';
import { clientCredentials, user } from '../../graphql/queries';
import { ColHead, ColError, ColLoading } from '../chunk'

class UserDetail extends React.Component {
	
	render() {

		let { loading, error, user } = this.props.data;
		
		if( loading ) return (<div className="col col-2"><ColLoading /></div>)
    if( error ) return (<div className="col col-2"><ColError error={error} /></div>)

    const dateCreated = formatDate(user.dateCreated);
    //const dateBirth = formatDate(user.birthday);

		return (
      		<div className="col col-2" key={user.id}>
            <ColHead title="USER DETAIL" meta={`joined ${dateCreated}`} />

            <div className="avatar avatar--large" style={{backgroundImage: `url(/avatare/${user.avatar})`}}></div>
            <p style={{textAlign:'center', marginBottom: '2rem'}}>{user.name}</p>

            {user.phone && (
              <div>
                <label className="label" htmlFor="phone">Fon</label>
                <input id="phone" className="input" type="text" value={user.phone} disabled />
              </div>
            )}

            {user.email && (
              <div>
                <label className="label" htmlFor="email">E-Mail</label>
                <input id="email" className="input" type="email" value={user.email} disabled />
              </div>
              )}

            {user.birthday && (
              <div>
                <label className="label" htmlFor="birthday">Geburtstag</label>
                <input id="birthday" className="input" type="date" value={formatDateHTML(user.birthday)} disabled />
              </div>
            )}

            <Query query={clientCredentials}>
              {({ data, client }) => {
                if(data.clientCredentials.id === user.id) {
                  return (
                    <div className="button-wrap">
                      <NavLink to={`/users/${user.id}/edit`} className="button">edit</NavLink>
                    </div>)
                }
                return null;
              }}
            </Query>
          </div>
      	)
	}
}

const queryOptions = {
  options: props => ({
    variables: { id: props.match.params.id }
  })
}

export default withApollo(graphql(user, queryOptions)(UserDetail))


// WEBPACK FOOTER //
// ./src/components/user/UserDetail.js